import React, { useState } from "react";
import styles from "../styles/Perfiles.module.css";
import { IoTrashOutline } from "react-icons/io5";
import EnlacesField from "../../../components/EnlacesField";

import { usePerfilCatalogos } from "../hooks/usePerfilCatalogos";
import { usePerfilLoad } from "../hooks/usePerfilLoad";
import { useImagePreview } from "../hooks/useImagePreview";
import { usePerfilSave } from "../hooks/usePerfilSave";

import { updateArrayItem, removeArrayItem } from "../domain/perfilForm";

const AñadirPerfil = ({ onPersonaCreada, persona, personaId }) => {
  const { tiposDocumento, tipoArmas, tipoLicencias, alergenosDisponibles } = usePerfilCatalogos();
  const { form, setForm } = usePerfilLoad({ persona, personaId });

  // ficheros (agrupados)
  const [files, setFiles] = useState({
    fileDocIdentidad: null,
    fileLicenciaCaza: null,
    fileSeguro: null,
    fileFoto: null,
    fileLicenciaArmas: null,
  });

  const [armasGuiaFiles, setArmasGuiaFiles] = useState({});

  const fotoPreview = useImagePreview({ file: files.fileFoto, fallbackUrl: form.foto });

  const {
    errores,
    isSubmitting,
    handleSubmit,
    clearFieldOnly,
    deleteFromServerAndClear,
    handleEliminarArmaSafe,
  } = usePerfilSave({
    form,
    setForm,
    personaId,
    onPersonaCreada,
    tiposDocumento,
    tipoArmas,
    tipoLicencias,
    files,
    setFiles,
    armasGuiaFiles,
    setArmasGuiaFiles,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleArrayChange = (index, field, value, arrayName) => {
    setForm((prev) => ({
      ...prev,
      [arrayName]: updateArrayItem(prev[arrayName], index, { [field]: value }),
    }));
  };

  const agregarElemento = (arrayName, emptyObject) => {
    setForm((prev) => ({
      ...prev,
      [arrayName]: [...(prev[arrayName] || []), emptyObject],
    }));
  };

  const eliminarElemento = (arrayName, index) => {
    setForm((prev) => ({
      ...prev,
      [arrayName]: removeArrayItem(prev[arrayName], index),
    }));
  };

  return (
    <div className={styles["formulario-persona"]}>
      <form className={styles["perfil-box"]} onSubmit={handleSubmit}>
        <h2>{personaId ? "Editar Perfil" : "Nuevo Perfil"}</h2>

        <div className={styles["perfil-info"]}>
          <div className={styles["info-bloque"]}>
            <div className={styles["info-header"]}><strong>Tipo de persona</strong></div>
            <div className={styles["info-content"]}>
              <label>Tipo</label>
              <select
                value={form.tipoPersona}
                onChange={(e) => setForm({ ...form, tipoPersona: e.target.value })}
                required
              >
                <option value="CLIENTE">Cliente</option>
                <option value="STAFF">Staff</option>
                <option value="TITULAR">Titular</option>
                <option value="AGENTE">Agente</option>
                <option value="OTRO">Otro</option>
              </select>
            </div>
          </div>

          <div className={styles["info-bloque"]}>
            <div className={styles["info-header"]}>
              <label>Foto (subir JPG/PNG/WebP)</label>
              {fotoPreview && (
                <div style={{ marginTop: 8 }}>
                  <div
                    style={{
                      width: 96,
                      height: 96,
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "1px solid #ddd",
                    }}
                  >
                    <img
                      src={fotoPreview}
                      alt="Preview foto"
                      style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                    />
                  </div>
                </div>
              )}
              <div className={`${styles["file-row"]}`} style={{ marginTop: 8 }}>
                <div className={styles["file-control"]} style={{ flex: 1 }}>
                  <input
                    className={styles["file-input"]}
                    type="file"
                    accept="image/*"
                    onChange={(e) => setFiles((p) => ({ ...p, fileFoto: e.target.files?.[0] ?? null }))}
                  />
                  {form.foto && (
                    <button
                      type="button"
                      className={styles["file-remove-icon"]}
                      title="Quitar del formulario"
                      onClick={() => clearFieldOnly("foto")}
                    >
                      Borrar
                    </button>
                  )}
                </div>

                {form.foto && (
                  <button
                    type="button"
                    className={styles["eliminar-boton"]}
                    onClick={() => deleteFromServerAndClear("foto", form.foto)}
                  >
                    <IoTrashOutline size={16} /> Borrar de forma definitiva
                  </button>
                )}
              </div>

              {form.foto && (
                <div className={styles["file-meta"]}>
                  <a href={form.foto} target="_blank" rel="noreferrer">
                    Ver archivo subido
                  </a>
                </div>
              )}
            </div>

            <div className={styles["info-header"]}>
              <strong>Datos Personales</strong>
            </div>

            <div className={styles["info-grid"]}>
              <div className={styles.field}>
                <label>Tratamiento</label>
                <input
                  type="text"
                  name="tratamiento"
                  placeholder="Ej: Sr."
                  value={form.tratamiento}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.field}>
                <label>Nombre</label>
                <input type="text" name="nombre" placeholder="Ej: Juan" value={form.nombre} onChange={handleChange} required />
              </div>

              <div className={styles.field}>
                <label>Segundo Nombre</label>
                <input type="text" name="nombre2" placeholder="Ej: Carlos" value={form.nombre2} onChange={handleChange} />
              </div>

              <div className={styles.field}>
                <label>Apellidos</label>
                <input
                  type="text"
                  name="apellidos"
                  placeholder="Ej: Pérez Gómez"
                  value={form.apellidos}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className={styles.field}>
                <label>Nickname</label>
                <input type="text" name="nickname" placeholder="Ej: juanito123" value={form.nickname} onChange={handleChange} />
              </div>

              <div className={styles.field}>
                <label>Email</label>
                <input type="email" name="email" placeholder="Ej: juan@email.com" value={form.email} onChange={handleChange} />
                {errores.email && <span className={styles.error}>{errores.email}</span>}
              </div>

              <div className={styles.field}>
                <label>Teléfono</label>
                <input type="text" name="telefono" placeholder="Ej: +34612345678" value={form.telefono} onChange={handleChange} />
                {errores.telefono && <span className={styles.error}>{errores.telefono}</span>}
              </div>

              <div className={styles.field}>
                <label>Dirección</label>
                <input type="text" name="direccion" placeholder="Ej: Calle Mayor 5" value={form.direccion} onChange={handleChange} />
              </div>

              <div className={styles.field}>
                <label>País</label>
                <input type="text" name="pais" placeholder="Ej: España" value={form.pais} onChange={handleChange} />
              </div>

              <div className={styles.field}>
                <label>Provincia</label>
                <input type="text" name="provincia" placeholder="Ej: Sevilla" value={form.provincia || ""} onChange={handleChange} />
              </div>

              <div className={styles.field}>
                <label>Código Postal</label>
                <input type="text" name="codigoPostal" placeholder="Ej: 41001" value={form.codigoPostal || ""} onChange={handleChange} />
              </div>
            </div>
          </div>

          <div className={styles["info-bloque"]}>
            <div className={styles["info-header"]}>
              <strong>Persona de contacto</strong>
            </div>

            <div className={styles["info-grid"]}>
              <div className={styles.field}>
                <label>Nombre</label>
                <input type="text" name="contacto" placeholder="Ej: María López" value={form.contacto} onChange={handleChange} />
              </div>

              <div className={styles.field}>
                <label>Email</label>
                <input type="email" name="emailContacto" placeholder="Ej: juan@email.com" value={form.emailContacto} onChange={handleChange} />
                {errores.emailContacto && <span className={styles.error}>{errores.emailContacto}</span>}
              </div>

              <div className={styles.field}>
                <label>Teléfono</label>
                <input type="text" name="telefonoContacto" placeholder="Ej: +34612345678" value={form.telefonoContacto} onChange={handleChange} />
                {errores.telefonoContacto && <span className={styles.error}>{errores.telefonoContacto}</span>}
              </div>
            </div>
          </div>

          <div className={styles["info-bloque"]}>
            <div className="form-group">
              <div className={styles["info-header"]}>
                <label>Alergenos</label>
              </div>

              <div className={styles["alergenos-checkbox-group"]}>
                {alergenosDisponibles.map((alergeno) => (
                  <label key={alergeno.id} className={styles["alergeno-checkbox"]}>
                    <input
                      type="checkbox"
                      value={alergeno.id}
                      checked={form.alergenos.includes(alergeno.id)}
                      onChange={() => {
                        const selected = form.alergenos.includes(alergeno.id)
                          ? form.alergenos.filter((id) => id !== alergeno.id)
                          : [...form.alergenos, alergeno.id];
                        setForm({ ...form, alergenos: selected });
                      }}
                    />
                    {alergeno.alergenoDescripcion}
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className={styles["info-bloque"]}>
            <div className={styles["info-header"]}>
              <strong>Documentación</strong>
            </div>

            <div className={styles["info-grid-2"]}>
              <div className={styles.field}>
                <label htmlFor="tipoDocumento">Tipo de Documento</label>
                <select id="tipoDocumento" name="tipoDocumento" value={form.tipoDocumento} onChange={handleChange}>
                  <option value="">Selecciona Tipo Documento</option>
                  {tiposDocumento.map((tipo, idx) => (
                    <option key={idx} value={tipo.codigo}>{tipo.descripcion}</option>
                  ))}
                </select>
                {errores.tipoDocumento && <span className={styles.error}>{errores.tipoDocumento}</span>}
              </div>

              <div className={styles.field}>
                <label htmlFor="numeroDocumento">Número de Documento</label>
                <input id="numeroDocumento" type="text" name="numeroDocumento" placeholder="Ej: 12345678X" value={form.numeroDocumento} onChange={handleChange} />
                {errores.numeroDocumento && <span className={styles.error}>{errores.numeroDocumento}</span>}
              </div>

              <div className={styles.field}>
                <label htmlFor="fechaCaducidad">Fecha de Caducidad</label>
                <input id="fechaCaducidad" type="date" name="fechaCaducidad" value={form.fechaCaducidad} onChange={handleChange} />
              </div>

              <div className={styles.field}>
                <label>Documento Identidad (subir PDF/imagen)</label>
                <div className={styles["file-row"]}>
                  <div className={styles["file-control"]} style={{ flex: 1 }}>
                    <input
                      className={styles["file-input"]}
                      type="file"
                      accept="image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                      onChange={(e) => setFiles((p) => ({ ...p, fileDocIdentidad: e.target.files?.[0] ?? null }))}
                    />
                    {form.imagenDocumento && (
                      <button type="button" className={styles["file-remove-icon"]} onClick={() => clearFieldOnly("imagenDocumento")}>Borrar</button>
                    )}
                  </div>

                  {form.imagenDocumento && (
                    <button
                      type="button"
                      className={styles["eliminar-boton"]}
                      onClick={() => deleteFromServerAndClear("imagenDocumento", form.imagenDocumento)}
                    >
                      <IoTrashOutline size={16} /> Borrar de forma definitiva
                    </button>
                  )}
                </div>

                {form.imagenDocumento && (
                  <div className={styles["file-meta"]}>
                    <a href={form.imagenDocumento} target="_blank" rel="noreferrer">Ver archivo subido</a>
                  </div>
                )}

                <EnlacesField
                  value={form.imagenDocumentoEnlaces}
                  onChange={(enlaces) => setForm((prev) => ({ ...prev, imagenDocumentoEnlaces: enlaces }))}
                />
              </div>
            </div>
          </div>


          {/* Licencia Caza: */}
          <div className={styles["info-bloque"]}>
            <div className={styles["info-header"]}>
              <strong>Licencia de Caza</strong>
            </div>

            <div className={styles["info-grid-3"]}>
              <div className={styles.field}>
                <label>Número</label>
                <input
                  type="text"
                  name="licenciaCaza_numero"
                  placeholder="Ej: LC-2023-001"
                  value={form.licenciaCaza_numero}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.field}>
                <label>Fecha de Expedición</label>
                <input
                  type="date"
                  name="licenciaCaza_fechaDeExpedicion"
                  value={form.licenciaCaza_fechaDeExpedicion}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.field}>
                <label>Fecha de Caducidad</label>
                <input
                  type="date"
                  name="licenciaCaza_fechaCaducidad"
                  value={form.licenciaCaza_fechaCaducidad}
                  disabled={!!form.licenciaCaza_fechaIndefinida}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.field}>
                <label>
                  <input
                    type="checkbox"
                    checked={!!form.licenciaCaza_fechaIndefinida}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setForm((prev) => ({
                        ...prev,
                        licenciaCaza_fechaIndefinida: checked,
                        licenciaCaza_fechaCaducidad: checked ? "" : prev.licenciaCaza_fechaCaducidad,
                      }));
                    }}
                  />{" "}
                  Sin fecha de caducidad (indefinida)
                </label>
              </div>

              <div className={styles.field}>
                <label>Documento de Licencia (subir PDF/imagen)</label>
                <div className={`${styles["file-row"]}`}>
                  <div className={styles["file-control"]} style={{ flex: 1 }}>
                    <input
                      className={styles["file-input"]}
                      type="file"
                      accept="image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                      onChange={(e) => setFiles((p) => ({ ...p, fileLicenciaCaza: e.target.files?.[0] ?? null }))}
                    />
                    {form.licenciaCaza_rutaDocumento && (
                      <button
                        type="button"
                        className={styles["file-remove-icon"]}
                        onClick={() => clearFieldOnly("licenciaCaza_rutaDocumento")}
                      >
                        Borrar
                      </button>
                    )}
                  </div>

                  {form.licenciaCaza_rutaDocumento && (
                    <button
                      type="button"
                      className={styles["eliminar-boton"]}
                      onClick={() => deleteFromServerAndClear("licenciaCaza_rutaDocumento", form.licenciaCaza_rutaDocumento)}
                    >
                      <IoTrashOutline size={16} /> Borrar de forma definitiva
                    </button>
                  )}
                </div>

                {form.licenciaCaza_rutaDocumento && (
                  <div className={styles["file-meta"]}>
                    <a href={form.licenciaCaza_rutaDocumento} target="_blank" rel="noreferrer">
                      Ver archivo subido
                    </a>
                  </div>
                )}

                <EnlacesField
                  value={form.licenciaCaza_enlaces}
                  onChange={(enlaces) => setForm((prev) => ({ ...prev, licenciaCaza_enlaces: enlaces }))}
                />
              </div>
            </div>
          </div>


          {/* Seguro */}
          <div className={styles["info-bloque"]}>
            <div className={styles["info-header"]}>
              <strong>Seguro</strong>
            </div>

            <div className={styles["info-grid-2"]}>
              <div className={styles.field}>
                <label>Fecha de Caducidad</label>
                <input type="date" name="seguro_fechaDeCaducidad" value={form.seguro_fechaDeCaducidad} onChange={handleChange} />
              </div>

              <div className={styles.field}>
                <label>Documento de Seguro (subir PDF/imagen)</label>
                <div className={`${styles["file-row"]}`}>
                  <div className={styles["file-control"]} style={{ flex: 1 }}>
                    <input
                      className={styles["file-input"]}
                      type="file"
                      accept="image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                      onChange={(e) => setFiles((p) => ({ ...p, fileSeguro: e.target.files?.[0] ?? null }))}
                    />
                    {form.seguro_rutaDocumento && (
                      <button type="button" className={styles["file-remove-icon"]} onClick={() => clearFieldOnly("seguro_rutaDocumento")}>
                        Borrar
                      </button>
                    )}
                  </div>

                  {form.seguro_rutaDocumento && (
                    <button
                      type="button"
                      className={styles["eliminar-boton"]}
                      onClick={() => deleteFromServerAndClear("seguro_rutaDocumento", form.seguro_rutaDocumento)}
                    >
                      <IoTrashOutline size={16} /> Borrar de forma definitiva
                    </button>
                  )}
                </div>

                {form.seguro_rutaDocumento && (
                  <div className={styles["file-meta"]}>
                    <a href={form.seguro_rutaDocumento} target="_blank" rel="noreferrer">Ver archivo subido</a>
                  </div>
                )}

                <EnlacesField
                  value={form.seguro_enlaces}
                  onChange={(enlaces) => setForm((prev) => ({ ...prev, seguro_enlaces: enlaces }))}
                />
              </div>
            </div>
          </div>

          {/* Licencias Armas + documento */}
          <div className={styles["info-bloque"]}>
            <div className={styles["info-header"]}>
              <strong>Licencias de Armas</strong>
              <button
                type="button"
                className={styles["btn-add"]}
                onClick={() =>
                  agregarElemento("licenciasArmas", {
                    id: null,
                    tipo: "",
                    pais: "",
                    fechaDeExpedicion: "",
                    fechaValidez: "",
                    fechaIndefinida: false,
                  })
                }
              >
                + Añadir
              </button>
            </div>

            {form.licenciasArmas.map((licencia, index) => (
              <div className={`${styles["info-grid"]} ${styles.bordered}`} key={index}>
                <div className={styles.field}>
                  <label>Tipo</label>
                  <select value={licencia.tipo} onChange={(e) => handleArrayChange(index, "tipo", e.target.value, "licenciasArmas")}>
                    <option value="">Selecciona Tipo de Licencia</option>
                    {tipoLicencias.map((tipo, idx) => (
                      <option key={idx} value={tipo.codigo}>{tipo.descripcion}</option>
                    ))}
                  </select>
                </div>

                <div className={styles.field}>
                  <label>País</label>
                  <input type="text" value={licencia.pais} onChange={(e) => handleArrayChange(index, "pais", e.target.value, "licenciasArmas")} />
                </div>

                <div className={styles.field}>
                  <label>Fecha Expedición</label>
                  <input type="date" value={licencia.fechaDeExpedicion} onChange={(e) => handleArrayChange(index, "fechaDeExpedicion", e.target.value, "licenciasArmas")} />
                </div>

                <div className={styles.field}>
                  <label>Fecha Validez</label>
                  <input
                    type="date"
                    value={licencia.fechaValidez}
                    disabled={!!licencia.fechaIndefinida}
                    onChange={(e) => handleArrayChange(index, "fechaValidez", e.target.value, "licenciasArmas")}
                  />
                  {errores[`licenciasArmas_fechaValidez_${index}`] && (
                    <span className={styles.error}>{errores[`licenciasArmas_fechaValidez_${index}`]}</span>
                  )}
                </div>

                <div style={{ gridColumn: "1 / -1", textAlign: "right" }}>
                  {form.licenciasArmas.length > 1 && (
                    <button type="button" className={styles["eliminar-boton"]} onClick={() => eliminarElemento("licenciasArmas", index)}>
                      <IoTrashOutline size={16} /> Eliminar
                    </button>
                  )}
                </div>
              </div>
            ))}

            <label>Documento de licencia de armas (subir PDF/imagen)</label>
            <div className={`${styles["file-row"]}`}>
              <div className={styles["file-control"]} style={{ flex: 1 }}>
                <input
                  className={styles["file-input"]}
                  type="file"
                  accept="image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                  onChange={(e) => setFiles((p) => ({ ...p, fileLicenciaArmas: e.target.files?.[0] ?? null }))}
                />
                {form.licenciaArmas_rutaDocumento && (
                  <button type="button" className={styles["file-remove-icon"]} onClick={() => clearFieldOnly("licenciaArmas_rutaDocumento")}>
                    Borrar
                  </button>
                )}
              </div>

              {form.licenciaArmas_rutaDocumento && (
                <button
                  type="button"
                  className={styles["eliminar-boton"]}
                  onClick={() => deleteFromServerAndClear("licenciaArmas_rutaDocumento", form.licenciaArmas_rutaDocumento)}
                >
                  <IoTrashOutline size={16} /> Borrar de forma definitiva
                </button>
              )}
            </div>

            {form.licenciaArmas_rutaDocumento && (
              <div className={styles["file-meta"]}>
                <a href={form.licenciaArmas_rutaDocumento} target="_blank" rel="noreferrer">Ver archivo subido</a>
              </div>
            )}

            <EnlacesField
              value={form.licenciaArmas_enlaces}
              onChange={(enlaces) => setForm((prev) => ({ ...prev, licenciaArmas_enlaces: enlaces }))}
            />
          </div>

          {/* Armas */}
          <div className={styles["info-bloque"]}>
            <div className={styles["info-header"]}>
              <strong>Armas</strong>
              <button
                type="button"
                className={styles["btn-add"]}
                onClick={() =>
                  agregarElemento("armas", {
                    modelo: "",
                    marca: "",
                    pais: "",
                    numeroGuia: "",
                    numeroSerie: "",
                    calibre: "",
                    tipoArma: "",
                    proximaReparacion: "",
                    rutaDocumentoGuiaArma: "",
                    enlaces: [],
                  })
                }
              >
                + Añadir
              </button>
            </div>

            {form.armas.map((arma, index) => (
              <div className={`${styles["info-grid"]} ${styles.bordered}`} key={index}>
                <div className={styles.field}>
                  <label>Modelo</label>
                  <input type="text" value={arma.modelo} onChange={(e) => handleArrayChange(index, "modelo", e.target.value, "armas")} />
                </div>

                <div className={styles.field}>
                  <label>Marca</label>
                  <input type="text" value={arma.marca} onChange={(e) => handleArrayChange(index, "marca", e.target.value, "armas")} />
                </div>

                <div className={styles.field}>
                  <label>País</label>
                  <input type="text" value={arma.pais} onChange={(e) => handleArrayChange(index, "pais", e.target.value, "armas")} />
                </div>

                <div className={styles.field}>
                  <label>Número de Guía</label>
                  <input type="text" value={arma.numeroGuia} onChange={(e) => handleArrayChange(index, "numeroGuia", e.target.value, "armas")} />
                </div>

                <div className={styles.field}>
                  <label>Número de Serie</label>
                  <input type="text" value={arma.numeroSerie} onChange={(e) => handleArrayChange(index, "numeroSerie", e.target.value, "armas")} />
                </div>

                <div className={styles.field}>
                  <label>Calibre</label>
                  <input type="text" value={arma.calibre} onChange={(e) => handleArrayChange(index, "calibre", e.target.value, "armas")} />
                </div>

                <div className={styles.field}>
                  <label>Tipo de Arma</label>
                  <select value={arma.tipoArma} onChange={(e) => handleArrayChange(index, "tipoArma", e.target.value, "armas")}>
                    <option value="">Selecciona tipo</option>
                    {tipoArmas.map((tipo, i) => (
                      <option key={i} value={tipo.codigo}>{tipo.descripcion}</option>
                    ))}
                  </select>
                </div>

                <div className={styles.field}>
                  <label>Próxima Reparación</label>
                  <input type="date" value={arma.proximaReparacion} onChange={(e) => handleArrayChange(index, "proximaReparacion", e.target.value, "armas")} />
                </div>

                <div className={styles.field}>
                  <label>Documento guía de arma (PDF/imagen)</label>
                  <div className={styles["file-row"]}>
                    <div className={styles["file-control"]} style={{ flex: 1 }}>
                      <input
                        className={styles["file-input"]}
                        type="file"
                        accept="image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                        onChange={(e) =>
                          setArmasGuiaFiles((prev) => ({
                            ...prev,
                            [index]: e.target.files?.[0] ?? null,
                          }))
                        }
                      />

                      {arma.rutaDocumentoGuiaArma && (
                        <button
                          type="button"
                          className={styles["file-remove-icon"]}
                          onClick={() => {
                            const updated = [...form.armas];
                            updated[index] = { ...updated[index], rutaDocumentoGuiaArma: "" };
                            setForm((prev) => ({ ...prev, armas: updated }));
                            setArmasGuiaFiles((prev) => {
                              const copy = { ...prev };
                              delete copy[index];
                              return copy;
                            });
                          }}
                        >
                          Borrar
                        </button>
                      )}
                    </div>

                    {arma.rutaDocumentoGuiaArma && (
                      <button
                        type="button"
                        className={styles["eliminar-boton"]}
                        onClick={() => deleteFromServerAndClear("rutaDocumentoGuiaArma", arma.rutaDocumentoGuiaArma)}
                      >
                        <IoTrashOutline size={16} /> Borrar de forma definitiva
                      </button>
                    )}
                  </div>

                  {arma.rutaDocumentoGuiaArma && (
                    <div className={styles["file-meta"]}>
                      <a href={arma.rutaDocumentoGuiaArma} target="_blank" rel="noreferrer">
                        Ver guía de arma
                      </a>
                    </div>
                  )}

                  <EnlacesField
                    value={arma.enlaces}
                    onChange={(enlaces) => handleArrayChange(index, "enlaces", enlaces, "armas")}
                  />
                </div>

                <div style={{ gridColumn: "1 / -1", textAlign: "right" }}>
                  <button type="button" className={styles["eliminar-boton"]} onClick={() => handleEliminarArmaSafe(index, arma.id)}>
                    <IoTrashOutline size={16} /> Eliminar
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className={styles["info-bloque"]}>
            <div className={styles["info-header"]}>
              <strong>Comentarios</strong>
            </div>
            <label className={styles["sr-only"]}>Comentarios</label>
            <textarea name="comentarios" placeholder="Escribe tus comentarios aquí" value={form.comentarios || ""} onChange={handleChange} />
          </div>
        </div>

        <div className={styles["form-footer"]}>
          <button type="submit" className={styles["add-button-global"]} disabled={isSubmitting}>
            {isSubmitting ? "Guardando..." : personaId ? "Guardar Cambios" : "Crear Persona"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AñadirPerfil;
